import React, { Fragment } from 'react';
import { capitalize } from '@mui/material';
import ToggleOff from '@mui/icons-material/ToggleOffOutlined';
import ToggleOn from '@mui/icons-material/ToggleOn';
import ExpandIcon from '@mui/icons-material/ExpandCircleDownOutlined';
import Select from 'react-select';
import ColorPicker from '../../../Components/ColorPicker';
import { DeleteIcon } from '../../../svg/UtilsIcons';
import CreateDatastream from './CreateDatastream';

const TableWidgetSettings = ({
	edit,
	setEdit,
	t,
	chartTypes,
	aggregations,
	devices,
	validDatastreams,
	deviceSelectOptions,
	setAddDatastream,
	isHiddenWidgetEditorPropKey,
	themeColorKey,
	themeColorValue,
}) => (
<Fragment>
											{Object.keys(edit.props)
												.filter(k => !['xData', 'headerBgColor', 'headerTextColor', 'bodyBgColor', 'bodyTextColor', 'showTitle', 'labelFontSize', 'valueFontSize', 'contentAlignment'].includes(k) && !isHiddenWidgetEditorPropKey(k))
												.map((key, idx) => (
													<div className="form-item" key={idx}>
														<label className="form-lbl" style={{ color: 'var(--header-color)' }}>
															{t.settingsLabels?.[key] || key}
														</label>
														{key === 'chart_type' ?
															<Select
																classNamePrefix="react-select"
																options={chartTypes.map(o => ({ label: o.label, value: o.value }))}
																value={chartTypes.map(o => ({ label: o.label, value: o.value })).find(o => o.value === edit.props.chart_type)}
																onChange={selectedOption =>
																	setEdit(prev => ({
																		...prev,
																		props: { ...prev.props, chart_type: selectedOption ? selectedOption.value : '' },
																	}))
																}
																isClearable={true}
															/>
															: key === 'curves' ?
																<Fragment>
																	<button
																		className="details-add-btn"
																		style={{ width: '120px' }}
																		onClick={() =>
																			setEdit(prev => ({
																				...prev,
																				props: {
																					...prev.props,
																					curves: [
																						...(prev.props.curves || []),
																						{
																							deviceId: 0,
																							pin: '',
																							aggregation: 'mean',
																							yData: [],
																							yLabel: 'Label',
																							customize: false,
																							min: 0,
																							max: 0
																						}
																					]
																				},
																				showCurves: [...(prev.showCurves || []), false]
																			}))
																		}
																	>
																		<span>+</span><span>{t.addColumn}</span>
																	</button>

																	{(edit.props.curves || []).map((column, index) => {
																		return (
																			<div className="details-curves-item" key={index}>
																				<div
																					className="details-hierarchy-tree"
																					style={{ width: '100%', flexDirection: 'row' }}
																				>
																					<button
																						className="details-actions-btn"
																						onClick={() =>
																							setEdit(prev => ({
																								...prev,
																								showCurves: (prev.showCurves || []).map((sh, i) =>
																									i === index ? !sh : sh
																								),
																							}))
																						}
																					>
																						<ExpandIcon
																							style={{
																								transform: (edit.showCurves || [])[index] ? 'rotate(180deg)' : 'rotate(0)',
																								transition: 'transform .2s linear',
																							}}
																						/>
																					</button>

																					<input
																						type="text"
																						className="add-column"
																						placeholder={t.label}
																						style={{
																							width: 'calc(100% - 64px)',
																							padding: '4px 10px',
																							marginInlineEnd: 4,
																							color: 'var(--cell--color)',
																							caretColor: 'var(--cell--color)',
																						}}
																						value={column.yLabel}
																						onChange={e =>
																							setEdit(prev => ({
																								...prev,
																								props: {
																									...prev.props,
																									curves: (prev.props.curves || []).map((c, i) =>
																										i === index ? { ...c, yLabel: e.target.value } : c
																									),
																								},
																							}))
																						}
																					/>

																					<button
																						className="details-delete-btn"
																						style={{ position: 'static' }}
																						onClick={() =>
																							setEdit(prev => ({
																								...prev,
																								showCurves: (prev.showCurves || []).filter((_, i) => i !== index),
																								props: {
																									...prev.props,
																									curves: (prev.props.curves || []).filter((_, i) => i !== index),
																								},
																							}))
																						}
																					>
																						<DeleteIcon  />
																					</button>
																				</div>

																				{edit.showCurves[index] &&
																					Object.keys(column)
																						.filter(k => k !== 'yLabel' && k !== 'yData' && !k.toLowerCase().includes('color'))
																						.map((k, i) => (
																							<div
																								className="form-item"
																								key={i}
																								style={
																									k.toLowerCase().includes('color')
																										? { display: 'inline-block', width: '33%' }
																										: k === 'aggregation' || k === 'pin'
																											? { display: 'inline-block', width: '75%', marginInlineEnd: '1%' }
																											: { display: 'block', width: '100%' }
																								}
																							>
																								{!(!column.customize && (k === 'min' || k === 'max')) && (
																									<label className="form-lbl" style={{ color: 'var(--header-color)' }}>
																										{(devices?.length > 0 && k === 'pin') ? '' : (t.settingsLabels?.[k] || k)}
																									</label>
																								)}

																								{k === 'pin' ? (
																									validDatastreams?.length > 0 ? (
																										<Select
																											classNamePrefix="react-select"
																											options={validDatastreams.map(d => ({
																												label: `${d.name} [${d.pin}]`,
																												value: d.pin,
																											}))}
																											value={validDatastreams.map(d => ({ label: `${d.name} [${d.pin}]`, value: d.pin })).find(d => d.value === column.pin)}
																											onChange={selectedOption => {
																												const found = validDatastreams.find(d => d.pin === (selectedOption ? selectedOption.value : ''));
																												if (!found) return;
																												setEdit(prev => ({
																													...prev,
																													props: {
																														...prev.props,
																														curves: (prev.props.curves || []).map((c, id) =>
																															id === index
																																? { ...c, pin: found?.pin || '', yLabel: found?.name || '' }
																																: c
																														),
																													},
																												}));
																											}}
																											isClearable={true}
																										/>
																									) : devices?.length > 0 ? (
																										<div>
																											<div className="form-item">
																												<label className="form-lbl">{t.deviceLabel}</label>
																												<Select
																													classNamePrefix="react-select"
																													options={deviceSelectOptions}
																													value={deviceSelectOptions.find(dev => dev.value === column.deviceId)}
																													onChange={selectedOption => {
																														setEdit(prev => ({
																															...prev,
																															props: {
																																...prev.props,
																																curves: (prev.props.curves || []).map((c, i) =>
																																	i === index
																																		? { ...c, deviceId: selectedOption ? selectedOption.value : 0 }
																																		: c
																																),
																															},
																														}));
																													}}
																													isClearable={true}
																												/>
																											</div>

																											{(() => {
																												const thisDevice = ((devices || []).find(dev => dev.id === column.deviceId));
																												const thisDeviceDs = (thisDevice?.template?.datastreams || []).filter(ds => ds);
																												return thisDeviceDs.length > 0 ? (
																													<div>
																														<label className="form-lbl" style={{ color: 'var(--header-color)' }}>
																															{t.pinLabel}
																														</label>
																														<Select
																															classNamePrefix="react-select"
																															options={thisDeviceDs.map(ds => ({
																																label: `${ds.name} [${ds.pin}]`,
																																value: ds.pin,
																															}))}
																															value={thisDeviceDs.map(ds => ({ label: `${ds.name} [${ds.pin}]`, value: ds.pin })).find(ds => ds.value === column.pin)}
																															onChange={selectedOption => {
																																const datastream = thisDeviceDs.find(
																																	ds => ds.pin === (selectedOption ? selectedOption.value : '')
																																);
																																if (!datastream) return;
																																setEdit(prev => ({
																																	...prev,
																																	props: {
																																		...prev.props,
																																		curves: (prev.props.curves || []).map((c, id) =>
																																			id === index
																																				? { ...c, pin: datastream?.pin || '', yLabel: datastream?.name || '' }
																																				: c
																																		),
																																	},
																																}));
																															}}
																															isClearable={true}
																														/>
																													</div>
																												) : null;
																											})()}
																										</div>
																									) : (
																										<CreateDatastream
																											onSelect={cat =>
																												setAddDatastream({ edit: true, pinCategory: cat })
																											}
																										/>
																									)
																								) : k === 'aggregation' ? (
																									<Select
																										classNamePrefix="react-select"
																										options={aggregations.map(o => ({ label: o.label, value: o.value }))}
																										value={aggregations.map(o => ({ label: o.label, value: o.value })).find(o => o.value === column.aggregation)}
																										onChange={selectedOption =>
																											setEdit(prev => ({
																												...prev,
																												props: {
																													...prev.props,
																													curves: (prev.props.curves || []).map((c, id) =>
																														id === index ? { ...c, aggregation: selectedOption ? selectedOption.value : '' } : c
																													),
																												},
																											}))
																										}
																										isClearable={true}
																									/>
																								) : k === 'customize' ? (
																									column.customize ? (
																										<ToggleOn
																											onClick={() =>
																												setEdit(prev => ({
																													...prev,
																													props: {
																														...prev.props,
																														curves: (prev.props.curves || []).map((c, id) =>
																															id === index ? { ...c, customize: false } : c
																														),
																													},
																												}))
																											}
																										/>
																									) : (
																										<ToggleOff
																											onClick={() =>
																												setEdit(prev => ({
																													...prev,
																													props: {
																														...prev.props,
																														curves: (prev.props.curves || []).map((c, id) =>
																															id === index ? { ...c, customize: true } : c
																														),
																													},
																												}))
																											}
																										/>
																									)
																								) : (k === 'min' || k === 'max') && column.customize ? (
																									<input
																										type="number"
																										className="add-column"
																										placeholder={capitalize(k)}
																										value={column[k] ?? ''}
																										onChange={e =>
																											setEdit(prev => ({
																												...prev,
																												props: {
																													...prev.props,
																													curves: (prev.props.curves || []).map((c, id) =>
																														id === index ? { ...c, [k]: Number(e.target.value) } : c
																													),
																												},
																											}))
																										}
																									/>
																								) : null}
																							</div>
																						))}
																			</div>
																		);
																	})}
																</Fragment>
																: null}
													</div>
												))}

											<div style={{ display: 'flex', flexDirection: 'column', gap: '10px', marginTop: '10px' }}>
												{['headerBgColor', 'headerTextColor', 'bodyBgColor', 'bodyTextColor'].map((key, idx) => (
													<div className='form-item' key={idx}>
														<label className='form-lbl' style={{ color: 'var(--header-color)' }}>
															{t.settingsLabels?.[key] || capitalize(key.replace(/([A-Z])/g, ' $1').trim())}
														</label>
														<ColorPicker
															id={key}
															color={themeColorValue(edit.props, key)}
															setColor={(c) => setEdit(prev => ({
																...prev,
																props: { ...prev.props, [themeColorKey(key)]: c }
															}))}
														/>
													</div>
												))}
											</div>
										</Fragment>
);

export default TableWidgetSettings;
